import { useMemo } from 'react';

import { SearchExperience, type SearchStoreExperience } from '../../../common/constants/search';
import { useBootstrap, useCurrentUserId } from '../../store/bootstrap';
import { useSearch, useSelectedDatasource } from '../../store/search';

import { getSelectedFilters, type SelectedFiltersReturnType } from './get-selected-filters';


/**
 * QS-6991
 *
 * This hook is a shim allowing easy fg('search-page-relay-useselectedfilters-step-1')
 * This is a migration step in moving useSelectedFilters (a hook) to be getSelectedFilters (not a hook!)
 * This unblocks the relay migration and will allow an imperative search query approach
 *
 * In a later PR, we'll begin to pass in all the props needed at the callsites that have useSelectedFilters() and then even remove this hook!
 */
export const useSelectedFilters = ({
	experience = SearchExperience.SEARCH_PAGE,
}: {
	experience?: SearchStoreExperience;
}): SelectedFiltersReturnType => {
	const [search] = useSearch();
	const [selectedDatasource] = useSelectedDatasource();
	const [{ products, allFilterExcludedProducts, thirdPartyConfigs }] = useBootstrap();
	const currentUserId = useCurrentUserId();

	const { filters, selectedProducts, jsmIncidentFilterIds } = search;

	return useMemo(() => {
		return getSelectedFilters({
			filters,
			selectedProducts,
			selectedDatasource,
			availableProducts: products,
			allFilterExcludedProducts,
			thirdPartyConfigs,
			jsmIncidentFilterIds,
			experience,
			currentUserId,
		});
	}, [
		filters,
		selectedProducts,
		selectedDatasource,
		products,
		allFilterExcludedProducts,
		thirdPartyConfigs,
		jsmIncidentFilterIds,
		experience,
		currentUserId,
	]);
};
